import { render, staticRenderFns } from "./ViewPolice.vue?vue&type=template&id=92b7c404"
import script from "./ViewPolice.vue?vue&type=script&lang=js"
export * from "./ViewPolice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports